export default {
	title: 'Vyhledání podobchodníka',
	subsellerEmail: 'E-mail',
	subsellerFirstName: 'Jméno',
	subsellerSurname: 'Příjmení',
	subsellerLogin: 'Login podobchodníka',
};
